module.exports = __webpack_public_path__ + "img/label-2A4.723e0b11.jpeg";